import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { CollectionModel, CollectionsDataModel } from './types';

const selectState = (state: RootState): RootState['collections'] => state.collections;

export const selectCollectionById = createSelector(
    [
        (state: RootState) => selectState(state).records,
        (state: RootState, collectionId: string): string => collectionId,
    ],
    (records, collectionId): CollectionsDataModel | undefined => records[collectionId],
);

export const selectCollections = createSelector(
    [(state: RootState) => state, (state: RootState) => state.collections?.identifiers],
    (draft, identifiers) =>
        (identifiers || [])
            .map((id: string) => selectCollectionById(draft, id))
            .filter(Boolean) as CollectionModel[],
);

export const selectCollectionsLoading = (state: RootState) => state.collections.isLoading ?? false;
